import { discountApplies, subscriptionHasEndDate } from "Client/Detail/SubscriptionUtils";
import React from "react";
import Arrow from "./Arrow";
import SubscriptionDiv from "./SubscriptionDiv";
import { findEnumObject } from "utilities/enumutils";
import ChangeActiveSubscriptionModal from "Client/Detail/ChangeActiveSubscriptionModal";
import ChangeNextSubscriptionModal from "Client/Detail/ChangeNextSubscriptionModal";

interface Props {
  activeSubscription: server.dto.Subscription
  nextSubscription: server.dto.NextSubscription
  discount: server.dto.ClientDiscount
  client: server.dto.Client
  billingDetails: server.dto.ClientBillingDetails
  subscriptions: server.dto.Subscription[]
}

const ClientSubscriptionSummaryContent = (props: Props) => {
  const hasEndDate = subscriptionHasEndDate(props.activeSubscription);
  const nextDiscountApplies = discountApplies(props.activeSubscription.end, props.discount?.until);

  const nextDiscountPercentage = (nextDiscountApplies) ? props.activeSubscription.discount : null;

  const [showChangeActiveSubscriptionModal, setShowChangeActiveSubscriptionModal] = React.useState<boolean>(false);
  const [showChangeNextSubscriptionModal, setShowChangeNextSubscriptionModal] = React.useState<boolean>(false);



  return <div className="flex margin-bottom-huge">
    <SubscriptionDiv
      start={props.activeSubscription.start}
      type={findEnumObject(props.activeSubscription.type, serverReference.subscriptionTypes)}
      cycle={findEnumObject(props.activeSubscription.billingCycle, serverReference.billingCycles)}
      users={props.activeSubscription.internalUsers}
      discount={props.activeSubscription.discount}
      onClick={() => setShowChangeActiveSubscriptionModal(true)}
    />
    {hasEndDate && <Arrow daysLeft={props.activeSubscription.daysUntilEnd} />}
    {hasEndDate && <SubscriptionDiv
      start={props.activeSubscription.end}
      type={findEnumObject(props.nextSubscription.type, serverReference.subscriptionTypes)}
      cycle={findEnumObject(props.nextSubscription.billingCycle, serverReference.billingCycles)}
      users={props.nextSubscription.internalUsers}
      discount={nextDiscountPercentage}
      onClick={() => setShowChangeNextSubscriptionModal(true)}
    />}

    <ChangeActiveSubscriptionModal
      client={props.client}
      activeSubscription={props.activeSubscription}
      nextSubscription={props.nextSubscription}
      billingDetails={props.billingDetails}
      subscriptions={props.subscriptions}

      isOpen={showChangeActiveSubscriptionModal}
      onClose={() => { setShowChangeActiveSubscriptionModal(false); }} />

    <ChangeNextSubscriptionModal
      client={props.client}
      activeSubscription={props.activeSubscription}
      nextSubscription={props.nextSubscription}
      isOpen={showChangeNextSubscriptionModal}
      onClose={() => { setShowChangeNextSubscriptionModal(false); }} />
  </div>;
};

export default ClientSubscriptionSummaryContent;
